import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
var _excluded = ["value", "className", "children", "icon", "iconPosition", "itemId", "onClick", "onKeyDown", "data-e2e"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, cloneElement } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './tab-list.p.module.css.js';
import { useTabListContext } from './tab-list-context.js';
var TabTag = /*#__PURE__*/forwardRef(function (props, ref) {
  if (typeof props.href !== 'undefined') {
    return /*#__PURE__*/React.createElement("a", _objectSpread({
      ref: ref
    }, props), props.children);
  }

  return /*#__PURE__*/React.createElement("button", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    type: "button"
  }), props.children);
});
TabTag.displayName = 'TabTag';
var Tab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cn;

  var value = _ref.value,
      className = _ref.className,
      children = _ref.children,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      itemId = _ref.itemId,
      _onClick = _ref.onClick,
      _onKeyDown = _ref.onKeyDown,
      e2eId = _ref['data-e2e'],
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useTabListContext = useTabListContext(),
      short = _useTabListContext.short,
      onChange = _useTabListContext.onChange,
      selectedId = _useTabListContext.selectedId;

  var selected = itemId === selectedId;
  var isRenderLeftIcon = icon && iconPosition === 'left';
  var isRenderRightIcon = icon && iconPosition === 'right';
  return /*#__PURE__*/React.createElement(TabTag, _objectSpread(_objectSpread({}, restProps), {}, {
    className: cn(styles.tab, (_cn = {}, _defineProperty(_cn, styles.selected, selected), _defineProperty(_cn, styles.short, short), _cn), className),
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }

      onChange(value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ') {
        e.target.click();
        e.preventDefault();
      }

      if (_onKeyDown) {
        _onKeyDown(e);
      }
    },
    role: "tab",
    tabIndex: 0,
    ref: ref,
    "data-e2e": e2eId,
    "data-test": "tab".concat(selected ? ' tab-selected' : '')
  }), isRenderLeftIcon && /*#__PURE__*/cloneElement(icon, {
    className: cn(icon.props.className, styles.icon, styles.iconLeft)
  }), /*#__PURE__*/React.createElement("div", null, children), isRenderRightIcon && /*#__PURE__*/cloneElement(icon, {
    className: cn(icon.props.className, styles.icon, styles.iconRight)
  }));
});
Tab.displayName = 'Tab';
Tab.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.symbol, PropTypes.object]),
  'data-e2e': PropTypes.string,
  itemId: PropTypes.number,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func
};
export { Tab as default };
